// Meili wraps matched terms in this highlight class. Show the field that
// actually contains a match so the row explains why it was found; body fields
// win, then the header fields, so a company/person-only match still shows.
const SEARCH_HIGHLIGHT_MARKER = "bg-amber-100"
const SEARCH_SNIPPET_FIELDS = [
	"text",
	"messages",
	"title",
	"person",
	"company",
] as const

export const pickMatchedSnippet = (
	formatted: Record<string, unknown> | undefined,
): string | null => {
	if (!formatted) return null
	for (const field of SEARCH_SNIPPET_FIELDS) {
		const value = formatted[field]
		if (typeof value === "string" && value.includes(SEARCH_HIGHLIGHT_MARKER)) {
			return value
		}
	}
	for (const field of ["text", "messages"] as const) {
		const value = formatted[field]
		if (typeof value === "string" && value.trim()) return value
	}
	return null
}
